import posthog from 'posthog-js';

// Analytics must never turn a successful user action into a user-facing failure.
export function captureEvent(name, properties) {
    try {
        posthog.capture(name, properties);
    } catch (error) {
        console.warn(`Could not record ${name} analytics.`, error);
    }
}
